/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHappyFilled = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM8 10V8h2v2H8zm6 0V8h2v2h-2zm1.21 3.398 1.58 1.228c-.693.89-1.991 1.963-3.694 2.282-1.775.331-3.805-.19-5.803-2.189l1.414-1.414c1.602 1.602 2.988 1.83 4.022 1.637 1.106-.207 2.007-.934 2.482-1.544z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHappyFilled as HappyFilled };
